import axios from "axios";
import React from "react";
import { connect } from "react-redux";
import NotFoundPage from "../screens/NotFound";

function RequireAuth({ children, userId, token }) {
  if (!!!userId) {
    return <NotFoundPage />;
  }
  axios.defaults.headers.common["Token"] = token;

  return <>{children}</>;
}

function mapStateToProps(state) {
  return {
    userId: state.login.login_data.user_id,
    token: state.login.login_data.token,
  };
}

export default connect(mapStateToProps)(RequireAuth);
// }
